import { render, staticRenderFns } from "./VDivider.vue?vue&type=template&id=538d6b23&lang=pug"
import script from "./VDivider.vue?vue&type=script&lang=js"
export * from "./VDivider.vue?vue&type=script&lang=js"
import style0 from "./VDivider.vue?vue&type=style&index=0&id=538d6b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports